import React from 'react';
import Slick from 'react-slick';
import NewsStoryCard from '../../desktop/NewStoryCard';
import NewsStoryCardMobile from '../../mobile/NewStoryCard';
import MoreButton from '../../../components_library/molecules/MoreButton/MoreButton';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';
import s from './PoliticalLeadersTimeline.scss';

const NextArrow = props => (
  <span {...props} className={`btn next ${props.className}`}>
    <i />
  </span>
);

const PrevArrow = props => (
  <span {...props} className={`btn prev ${props.className}`}>
    <i />
  </span>
);
const settings = {
  dots: true,
  slidesToShow: 5,
  slidesToScroll: 5,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  infinite: false,
};

class PoliticalLeadersTimeline extends React.Component {
  render() {
    const {
      isWapView,
      sectionData,
      name,
      theme,
      moreText,
      moreUrl,
    } = this.props;

    return (
      <div
        className={`${s.plTimelineWrap} ${
          theme && Array.isArray(theme)
            ? theme.map(t => s[t]).join(' ')
            : theme ? s[theme] : ''
        } slick_UI`}
      >
        <div className={s.title}>
          {name && <Listingheader headingname={name} />}
          {!isWapView &&
            moreText &&
            moreUrl && (
              <div className={s.budgetHistoryCtaWrap}>
                <MoreButton
                  absoluteMoreText={moreText}
                  moreLink={moreUrl}
                  moreText={moreText}
                  doNotChangeURL
                  isRedBrdr
                  isTextCapitalize
                />
              </div>
            )}
        </div>
        <div className={s.plTimeline}>
          {!isWapView && (
            <Slick {...settings}>
              {sectionData &&
                Array.isArray(sectionData) &&
                sectionData.length > 0 &&
                sectionData.map(item => (
                  <section className={s.cardWrap}>
                    <div className={s.year}>{item?.term}</div>
                    <NewsStoryCard
                      title={item.name}
                      msid={item.id}
                      syn={item.party}
                      cardType="card_26"
                      synStyle={{
                        color: item.color,
                      }}
                      target="_self"
                    />
                  </section>
                ))}
            </Slick>
          )}
          {isWapView &&
            sectionData &&
            Array.isArray(sectionData) &&
            sectionData.length > 0 &&
            sectionData.map(item => (
              <section className={s.cardWrap}>
                <div className={s.year}>{item?.term}</div>
                <NewsStoryCardMobile
                  title={item.name}
                  msid={item.id}
                  syn={item.party}
                  cardType="card_20"
                  synStyle={{
                    color: item.color,
                  }}
                  target="_self"
                />
              </section>
            ))}
        </div>
        {isWapView &&
          moreText &&
          moreUrl && (
            <div className={s.budgetHistoryCta}>
              <MoreButton
                absoluteMoreText={moreText}
                moreLink={moreUrl}
                moreText={moreText}
                doNotChangeURL
                isFullWidth
                isRedBrdr
                isTextCapitalize
              />
            </div>
          )}
      </div>
    );
  }
}

export default PoliticalLeadersTimeline;
